import { Text } from '@epam/promo';
import { dateToString } from '../../../hooks/helpers/date-time-helper';
import React from 'react';
import { DateStringProps } from './FormattedDate.model';

export const FormattedDate = ({ date }: DateStringProps) => (
  <Text
    color="gray60"
    fontSize="10"
    lineHeight="12"
    rawProps={{
      'data-testid': 'formatted-datestamp',
    }}
    size="none">
    {dateToString(date || new Date())}
  </Text>
);
